(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ask-chat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ask-chat-prompts')) return;

    const CHAT_TAG = 'shopify-chat';
    const DEFINE_TIMEOUT_MS = 4000;

    class AskChatPrompts extends HTMLElement {
      connectedCallback() {
        this.hint = this.querySelector('.ask-chat__hint');
        this.addEventListener('click', (event) => this.onClick(event));
        // Warm the chat bundle so the first click opens promptly.
        this.addEventListener('pointerenter', () => this.chatElement(), { once: true });
      }

      onClick(event) {
        const chip = event.target.closest('[data-ask-chat-message]');
        if (chip) {
          event.preventDefault();
          this.ask(chip.dataset.askChatMessage || chip.textContent.trim());
          return;
        }
        const toggle = event.target.closest('[data-ask-chat-more]');
        if (toggle) {
          event.preventDefault();
          this.toggleMore(toggle);
          return;
        }
        if (event.target.closest('[data-ask-chat-open]')) {
          event.preventDefault();
          this.openChat().then((opened) => {
            if (!opened) this.fallback('');
          });
        }
      }

      async ask(message) {
        const chat = this.chatElement();
        if (!chat) {
          this.fallback(message);
          return;
        }

        // Clipboard writes only succeed inside the user gesture, so do it first.
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(message);
            copied = true;
          }
        } catch (_) {
          copied = false;
        }
        if (!copied) copied = this.legacyCopy(message);

        const opened = await this.openChat();
        if (!opened) {
          this.fallback(message);
          return;
        }

        this.showHint(copied ? this.dataset.hint : this.dataset.hintManual, message, !copied);
      }

      toggleMore(toggle) {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        const expand = panel.hidden;
        panel.hidden = !expand;
        toggle.setAttribute('aria-expanded', String(expand));
        const label = toggle.querySelector('[data-ask-chat-more-label]');
        if (label) label.textContent = expand ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        if (expand) {
          const first = panel.querySelector('button');
          if (first) first.focus({ preventScroll: true });
        }
      }

      chatElement() {
        return document.querySelector(CHAT_TAG);
      }

      // Older Safari / embedded browsers refuse the async Clipboard API but
      // still honour execCommand('copy') inside a click.
      legacyCopy(message) {
        const area = document.createElement('textarea');
        area.value = message;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        area.style.pointerEvents = 'none';
        this.append(area);
        let ok = false;
        try {
          area.select();
          area.setSelectionRange(0, message.length);
          ok = document.execCommand('copy');
        } catch (_) {
          ok = false;
        }
        area.remove();
        return ok;
      }

      async openChat() {
        const chat = this.chatElement();
        if (!chat) return false;

        if (!customElements.get(CHAT_TAG)) {
          await Promise.race([
            customElements.whenDefined(CHAT_TAG),
            new Promise((resolve) => setTimeout(resolve, DEFINE_TIMEOUT_MS)),
          ]);
        }

        try {
          if (typeof chat.show === 'function') {
            chat.show();
          } else if ('open' in chat) {
            chat.open = true;
          } else {
            chat.setAttribute('open', '');
          }
          return true;
        } catch (_) {
          return false;
        }
      }

      fallback(message) {
        const base = this.dataset.fallback || '';
        if (!base) return;

        let href = base;
        if (base.startsWith('mailto:')) {
          const params = new URLSearchParams();
          if (this.dataset.subject) params.set('subject', this.dataset.subject);
          if (message) params.set('body', message);
          const query = params.toString().replace(/\+/g, '%20');
          href = query ? `${base}${base.includes('?') ? '&' : '?'}${query}` : base;
        }
        window.location.href = href;
      }

      showHint(template, message, includeMessage) {
        if (!this.hint) return;
        this.hint.textContent = '';
        this.hint.append(template || '');
        if (includeMessage && message) {
          const mark = document.createElement('mark');
          mark.textContent = message;
          this.hint.append(' ', mark);
        }
        this.hint.hidden = !this.hint.textContent.trim();
      }
    }

    customElements.define('ask-chat-prompts', AskChatPrompts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-footer-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ss-footer-main')) return;

    const DESKTOP_QUERY = '(min-width: 750px)';
    const CHAT_TAG = 'shopify-chat';
    const CHAT_DEFINE_TIMEOUT_MS = 4000;

    /**
     * Footer behaviour:
     *  - Link columns are <details>: accordions below 750px, always open and
     *    not toggleable from 750px up.
     *  - "Start a chat" opens Shopify Inbox via its <shopify-chat> element,
     *    falling back to the contact page when the chat isn't on the page.
     *
     * It is a custom element, so it sets itself up again whenever the theme
     * editor re-renders the section (shopify:section:load swaps in fresh
     * markup, which runs connectedCallback), and tears down listeners in
     * disconnectedCallback. Safe to run any number of times.
     */
    class SsFooterMain extends HTMLElement {
      connectedCallback() {
        this.mql = window.matchMedia(DESKTOP_QUERY);
        this.mode = null;
        this.handleMediaChange = () => this.syncColumns();
        this.handleClick = (event) => this.onClick(event);
        this.handleBlockSelect = (event) => this.onBlockSelect(event);

        if (typeof this.mql.addEventListener === 'function') {
          this.mql.addEventListener('change', this.handleMediaChange);
        } else {
          this.mql.addListener(this.handleMediaChange);
        }
        this.addEventListener('click', this.handleClick);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.syncColumns();
      }

      disconnectedCallback() {
        if (this.mql) {
          if (typeof this.mql.removeEventListener === 'function') {
            this.mql.removeEventListener('change', this.handleMediaChange);
          } else {
            this.mql.removeListener(this.handleMediaChange);
          }
        }
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      get columns() {
        return Array.from(this.querySelectorAll('details[data-ss-footer-col]'));
      }

      syncColumns() {
        const desktop = this.mql.matches;
        const mode = desktop ? 'desktop' : 'mobile';
        if (mode === this.mode) return;
        this.mode = mode;

        this.columns.forEach((column) => {
          const summary = column.querySelector(':scope > summary');
          column.open = desktop;
          if (!summary) return;
          if (desktop) {
            summary.setAttribute('tabindex', '-1');
            summary.setAttribute('aria-disabled', 'true');
          } else {
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          }
        });
      }

      onClick(event) {
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary) && summary.parentElement.hasAttribute('data-ss-footer-col')) {
          if (this.mql.matches) event.preventDefault();
          return;
        }

        const chatButton = event.target.closest('[data-ss-footer-chat]');
        if (chatButton && this.contains(chatButton)) {
          event.preventDefault();
          this.openChat(chatButton.dataset.fallback || '');
        }
      }

      onBlockSelect(event) {
        const target = event.target;
        if (!(target instanceof Element) || !this.contains(target)) return;
        const column = target.closest('details[data-ss-footer-col]');
        if (column) column.open = true;
      }

      openChat(fallback) {
        const goToFallback = () => {
          if (fallback) window.location.href = fallback;
        };

        const chat = document.querySelector(CHAT_TAG);
        if (!chat) {
          goToFallback();
          return;
        }

        const show = () => {
          try {
            if (typeof chat.show === 'function') {
              chat.show();
            } else if ('open' in chat) {
              chat.open = true;
            } else {
              chat.setAttribute('open', '');
            }
            return true;
          } catch (error) {
            return false;
          }
        };

        // Call show() straight away inside the click when the widget is ready.
        if (customElements.get(CHAT_TAG)) {
          if (!show()) goToFallback();
          return;
        }

        Promise.race([
          customElements.whenDefined(CHAT_TAG).then(() => true),
          new Promise((resolve) => setTimeout(() => resolve(false), CHAT_DEFINE_TIMEOUT_MS)),
        ]).then((defined) => {
          if (!defined || !show()) goToFallback();
        });
      }
    }

    customElements.define('ss-footer-main', SsFooterMain);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-plant-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ss-plant-finder')) return;

    // The cold question only comes in for a spot outdoors, or a planter that stays out all
    // winter: indoor places carry their own data-temp. An outdoor area skips the experience
    // question, because nearly every plant we list for the garden is tagged Beginner, and the
    // room question, so its plants can be any size.
    const FLOWS = {
      spot: ['route', 'locations', 'sun', 'temp', 'levels', 'size', 'colours'],
      planter: ['route', 'planter-place', 'sun', 'temp', 'planter-size', 'planter-density', 'levels', 'colours'],
      area: ['route', 'area-place', 'sun', 'temp', 'area-size', 'area-role', 'colours'],
    };
    // The question that asks where the plants will live, for each route.
    const PLACE_STEPS = { spot: 'locations', planter: 'planter-place', area: 'area-place' };
    const INDOOR_PLACES = ['Sunny Windowsill', 'Bright Indoor Table', 'Conservatory'];
    // Most succulents are happy outdoors, so for an outdoor place (an answer with data-outdoor)
    // the place's tags only rank the plants: tagged for that place first, then for any of
    // these, then the rest. Winter cold, light and the kind of plant still rule plants out.
    // A hanging basket isn't marked outdoor, because its tag is about a trailing habit.
    const OUTDOOR_PLACES = ['Patio', 'Balcony', 'Outdoor Tabletop', 'Rockery', 'In the Ground', 'Hanging Basket'];
    // Matching is fuzzy: when too few plants fit, answers are loosened one at a time until
    // enough do, and a loosened answer still ranks the plants that meet it first. Light goes
    // first, silently, when fewer than SUN_RELAX_BELOW plants (or too few for the mix) suit
    // the light, the place and the winter temperature together. The other answers don't
    // count towards that, so a narrower size or experience answer never brings in more
    // plants than a wider one. After light come these, in order, then a planter's width
    // (WIDTH_FUZZ) and last the winter temperature (TEMP_FUZZ).
    const RELAX_ORDER = ['size', 'forms', 'levels', 'locations'];
    const SUN_RELAX_BELOW = 10;
    // How far past the planter's narrowest width a plant's spread may go, in steps.
    const WIDTH_FUZZ = [1.25, 1.5, 2];
    // How many degrees warmer than the winter answer a plant may be rated, one at a time.
    // Cold kills plants, so this only loosens far enough for a few plants to choose from
    // (MIN_DISTINCT), never for a bigger mix.
    const TEMP_FUZZ = 6;
    // A picked mix has at least this many different plants (fewer only if its count is
    // smaller), and "Try another mix" can always bring in new ones: matching looks for this
    // many plus SPARE_PLANTS.
    const MIN_DISTINCT = 3;
    const SPARE_PLANTS = 2;
    // Genera that do well facing north even when tagged for full sun. For a north-facing
    // spot they count as partial shade, so they show after the plants tagged for shade.
    const NORTH_FACING_GENERA = ['Crassula'];
    const MIN_RESULTS = 3;
    // "Choose for me" picks from this many of the closest in-stock matches for each plant
    // asked for, so looking for variety never reaches down to a poor match.
    const PICK_POOL_PER_PLANT = 6;
    // "Choose for me" picks 1 to this many plants (the box under the results). 12 keeps US
    // shoppers under the import permit limit (assets/us-plant-limit.js).
    const MAX_CHOOSE = 12;
    // Planters up to this width (cm) at their narrowest leave out Aeoniums, which outgrow them.
    const SMALL_PLANTER = 35;
    // Aeoniums taller than this (cm) are left out of every mixed planter.
    const AEONIUM_MAX_HEIGHT = 60;
    // Genera that count as Aeoniums for those two rules: x Semponium is an Aeonium hybrid.
    const AEONIUM_GENERA = ['Aeonium', 'Semponium'];
    // Plants for every 10 cm across the planter (the square root of its top area), for each
    // answer to "How full would you like your planter?". The count follows the planter's
    // width rather than its area, because a bigger planter takes bigger plants set further
    // apart. Balanced puts 5 plants in a 30 cm bowl and 19 in a 1 m square bed.
    const DENSITY = { sparse: 1.2, balanced: 1.9, dense: 2.6 };
    // The gardener's golden rule: never plant in twos or fours, so a mixed planter never
    // gets 2 or 4 plants.
    const AVOID_COUNTS = [2, 4];
    // Over 60 cm x 60 cm (3600 cm²), a long or square planter needs larger plants than the shop
    // has, so the finder offers a contact form instead.
    const MAX_PLANTER_AREA = 3600;
    // A round planter more than this many centimetres across goes to the contact form.
    const MAX_ROUND_DIAMETER = 60;
    // An outdoor area over this many square centimetres (60 cm x 60 cm) goes to the contact
    // form too.
    const MAX_GARDEN_AREA = 3600;
    // A good fleece over plants in an outdoor area counts as this many degrees of protection,
    // so a winter answer of -5°C matches plants rated down to -2°C. It never goes above 5°C.
    const FLEECE_DEGREES = 3;
    // Pots under 15 cm across (a long planter by its longest side) get the cuttings bundle
    // instead of a mix: under 5 cm the 1 cm cuttings, up to the 5 cm cuttings under 15 cm.
    // cm is the bundle variant's size, read from its title ("1cm").
    const CUTTINGS_SIZES = [
      { under: 5, cm: 1 },
      { under: 8, cm: 2 },
      { under: 12, cm: 3 },
      { under: 15, cm: 5 },
    ];
    // The planter mix fills each place with a growth form (custom.growth_form).
    const ROLES = {
      tall: ['Shrub-like', 'Branching'],
      rosette: ['Singular rosette'],
      dense: ['Clumping', 'Ground/ pot cover'],
      trailing: ['Trailing'],
    };
    // When no plant of a role is left, the place goes to the next of these. A centrepiece
    // never falls back to a trailing plant: its listed height is the length of its trails.
    const ROLE_FALLBACKS = {
      tall: ['rosette', 'dense'],
      rosette: ['dense', 'tall'],
      dense: ['rosette', 'tall'],
      trailing: ['dense', 'rosette'],
    };
    const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

    const sunLevel = (sunlight) => {
      if (!sunlight) return 0;
      if (sunlight.includes('Full Sun')) return 3;
      if (sunlight.includes('Partial')) return 2;
      if (sunlight.includes('Shade')) return 1;
      return 0;
    };

    const list = (value) => (value ? value.split('|') : []);

    // The genus is the first word of the title, skipping the "x" of hybrid genera.
    const genus = (title) => title.split(/\s+/).find((word) => word.toLowerCase() !== 'x') || title;
    const sizeBand = (plant) => {
      const largest = Math.max(plant.height_cm || 0, plant.spread_cm || 0);
      return largest <= 20 ? 1 : largest <= 40 ? 2 : 3;
    };
    const hasForm = (plant, forms) => (plant.form || []).some((form) => forms.includes(form));
    // A planter's plant other than the centrepiece is labelled by its own form.
    const formRole = (plant) => (hasForm(plant, ROLES.trailing) ? 'trailing' : hasForm(plant, ROLES.rosette) ? 'rosette' : 'dense');

    // The planting zone a planter's plant goes in: its centrepiece in the tall centre,
    // trailing and ground cover plants at the low edge, and the rest in the middle.
    const EDGE_FORMS = [...ROLES.trailing, 'Ground/ pot cover'];
    const ZONES = ['centre', 'middle', 'edge'];
    const zoneOf = (plant) => {
      if (plant.role === 'tall') return 'centre';
      if (plant.role === 'trailing' || hasForm(plant, EDGE_FORMS)) return 'edge';
      return 'middle';
    };

    // A tall plant for the middle (one more for every 12 plants), trailing plants for the
    // edge (about one in six) and rosettes and denser plants in turn for the rest.
    const planterRoles = (count) => {
      const tall = Math.max(1, Math.floor(count / 12));
      const trailing = count >= 3 ? Math.max(1, Math.round(count / 6)) : 0;
      const roles = Array(tall).fill('tall');
      for (let i = 0; i < count - tall - trailing; i++) roles.push(i % 2 ? 'dense' : 'rosette');
      for (let i = 0; i < trailing; i++) roles.push('trailing');
      return roles.slice(0, count);
    };

    // Care sentences are written about one plant ([plant], it, its, "the rosette"). For several
    // plants, groupSentence rewrites them to talk about the group.
    const AUX = { is: 'are', was: 'were', has: 'have', does: 'do' };
    const MODALS = ['can', 'will', 'may', 'must', 'should', 'might', 'would', 'could'];
    const NOT_VERBS = ['as', 'across', 'always', 'towards', 'upwards', 'plus', 'its', 'us', 'this', 'thus', 'unless'];
    // Verbs whose "it" is always the plant, wherever they come in a sentence.
    const HANDLING = ['move', 'moving', 'place', 'placing', 'introduce', 'introducing', 'suits', 'protect', 'shade', 'position', 'repot', 'shift', 'bring', 'unpack', 'treat'];
    const OBJECT_VERBS = ['plant', 'water', 'give', 'keep', 'provide', 'send', 'slow', 'treat', 'move', 'protect', 'position', 'set', 'feed', 'repot', 'rotate', 'place', 'grow', 'leave', 'bring', 'unpack', 'pot', 'check', 'shift', 'shade', 'settle'];
    // Plural nouns that turn up where a verb could be: "the stem and roots", "it leaves".
    const S_NOUNS = ['leaves', 'roots', 'stems', 'rosettes', 'offsets', 'flowers', 'crowns', 'heads', 'spikes', 'colours', 'conditions', 'cultivars', 'species', 'plants', 'pots', 'holes'];
    // Words that can sit between a subject and its verb: "it still needs".
    const ADVERBS = '(?:\\s+(?:\\w+ly|still|also|often|then))*';
    const PREPOSITIONS = ['about', 'above', 'across', 'against', 'among', 'around', 'at', 'behind', 'below', 'between', 'by', 'for', 'from', 'in', 'into', 'near', 'of', 'on', 'onto', 'over', 'through', 'to', 'towards', 'under', 'with', 'without'];
    // Words after which "it" starts a clause, so it is the subject: "so it develops evenly".
    const CLAUSE_STARTS = ['and', 'but', 'or', 'so', 'as', 'when', 'while', 'until', 'once', 'before', 'after', 'if', 'unless', 'because', 'that', 'where', 'since', 'though'];
    // Parts of a plant that stand for it ("keep the crown above the surface"), and the other
    // things "it" can mean in care text ("water whenever the compost has dried").
    const PARTS = ['rosette', 'crown', 'stem', 'trunk', 'root ball', 'root system', 'growing point', 'mat', 'cluster', 'clump'];
    const NOT_PLANT = ['compost', 'soil', 'mix', 'mixture', 'pot', 'container', 'water', 'growth', 'substrate', 'spike', 'weather'];
    // A describing word before a noun: "a pot-grown plant", "the flat central crown".
    const MODIFIER = '(?:(?!(?:and|or|the|a|an|of|to|in|on|at|by|for|from|into|with|than|as)\\b)[a-z][a-z-]*,?\\s+)';
    // A sentence that sends the shopper to the plant's product page is about each plant.
    const OWN_PAGE = /product page|product's|\brecorded\b/;
    const EACH = /\[plant\]|\bthe plant\b|\bthe product's/;
    // The care profile written for any succulent, for a topic a mixed group has nothing in.
    const GENERAL_CARE = 'general-succulent';

    const plural = (verb) => {
      const lower = verb.toLowerCase();
      if (AUX[lower]) return AUX[lower];
      if (MODALS.includes(lower)) return verb;
      if (/(ch|sh|ss|x|z|o)es$/.test(verb)) return verb.slice(0, -2);
      if (/[^aeiou]ies$/.test(verb)) return verb.slice(0, -3) + 'y';
      return verb.slice(0, -1);
    };
    // A verb after "it" ends in s, but not in ss, us or is ("less", "humus").
    const isVerb = (word) => {
      const lower = (word || '').toLowerCase();
      if (AUX[lower] || MODALS.includes(lower)) return true;
      return /s$/.test(lower) && !/(ss|us|is)$/.test(lower) && !NOT_VERBS.includes(lower) && lower.length > 2;
    };
    // The verb after a plural subject: "needs" becomes "need" and "is" becomes "are".
    const agree = (verb) => {
      const lower = verb.toLowerCase();
      if (AUX[lower]) return AUX[lower];
      return isVerb(verb) && !MODALS.includes(lower) && !S_NOUNS.includes(lower) ? plural(verb) : verb;
    };
    // Verbs later in the clause that share the plural subject, joined by "and", "or" or "but":
    // "receive light and does not lean", "grow thin and flowers poorly". Only up to the next
    // noun with a determiner, since "and" after one usually joins nouns.
    const joinedVerbs = (rest) => {
      const [clause, ...after] = rest.split(/\b(?=(?:the|an?(?! (?:little|few|bit)\b)|their|its|your)\b)/);
      const joined = clause.replace(/\b(and|or|but) (\w+)(\s+\w+ly\b)?/g, (m, word, next, adverb = '') => {
        const lower = next.toLowerCase();
        if (AUX[lower]) return `${word} ${AUX[lower]}${adverb}`;
        if (isVerb(next) && !MODALS.includes(lower) && (adverb || !S_NOUNS.includes(lower))) return `${word} ${plural(next)}${adverb}`;
        return m;
      });
      return [joined, ...after].join('');
    };
    const pluralNoun = (noun) => (/(s|x|ch|sh)$/.test(noun) ? `${noun}es` : `${noun}s`);
    const capital = (text) => text.charAt(0).toUpperCase() + text.slice(1);

    // Makes the plant and its parts plural: "a pot-grown plant", "this tough, free-flowering
    // mat", "a compact branching Aeonium" (a genus in the group), "This species", "the plant"
    // and "the rosette, stem and roots". Each one is marked (\u0001 to \u0002) so that the
    // verb after it, and any "it" further on, can follow it. "the whole clump" becomes "each
    // whole clump", and a part in front of another noun stays as it is ("the crown rot").
    const pluralNouns = (text, genera) => {
      const mark = (words) => `\u0001${words}\u0002`;
      const nouns = ['plant', 'specimen', 'rosette', 'clump', 'mat', ...[...genera].filter((name) => /^[A-Z][a-z]+$/.test(name))].join('|');
      const parts = PARTS.join('|');
      const compound = `(?!['’]|\\s+(?:${S_NOUNS.join('|')}|rot)\\b)`;
      const listed = `${parts}|leaves|roots|stems|offsets`;
      let out = text
        .replace(new RegExp(`\\b(?:(than|like|unlike)\\s+)?([Aa]n?|[Tt]his)\\s+(${MODIFIER}{0,3}?)(${nouns})\\b(?!['’])`, 'g'), (m, than, det, mods, noun) => {
          // A comparison stays as it is: "not hardy like a Sempervivum".
          if (than) return m;
          const words = `${mods}${pluralNoun(noun)}`;
          if (/^this$/i.test(det)) return mark(`${det[0] === 'T' ? 'These' : 'these'} ${words}`);
          return mark(det[0] === 'A' ? capital(words) : words);
        })
        .replace(new RegExp(`\\b([Tt])his\\s+(${MODIFIER}{0,2}?)species\\b`, 'g'), (m, t, mods) => mark(`${t}hese ${mods}plants`))
        .replace(/\b([Tt])he plant\b(['’]s\b)?/g, (m, t, possessive) => `${mark(`${t}he plants`)}${possessive ? "'" : ''}`)
        .replace(
          new RegExp(`\\b([Tt]he\\s+(${MODIFIER}{0,2}?))(${parts})\\b${compound}((?:(?:,\\s+|\\s+(?:and|or)\\s+)(?:${listed})\\b${compound})*)`, 'g'),
          (m, the, mods, part, list) => {
            if (/^(?:whole|entire)\b/.test(mods)) return `${the[0] === 'T' ? 'Each' : 'each'} ${mods}${part}${list}`;
            return mark(`${the}${pluralNoun(part)}${list.replace(new RegExp(`\\b(${parts})\\b`, 'g'), pluralNoun)}`);
          }
        )
        // A part after plural ones: "the roots and crown".
        .replace(new RegExp(`\\b([Tt]he (?:leaves|roots|stems)(?:,\\s+(?:leaves|roots|stems))*\\s+(?:and|or)\\s+)(${parts})\\b${compound}`, 'g'), (m, the, part) =>
          mark(`${the}${pluralNoun(part)}`)
        );
      // The verb after a plural subject agrees with it, and so do the verbs joined to that one.
      // After a preposition the plants are not the subject: "grit around the plants keeps".
      const subject = new RegExp(`(?:\\b(\\w+)\\s+)?\u0001[^\u0002]*\u0002(${ADVERBS}\\s+)(\\w+)`, 'g');
      let found;
      while ((found = subject.exec(out))) {
        const [whole, before, gap, verb] = found;
        const end = found.index + whole.length;
        subject.lastIndex = end - gap.length - verb.length;
        if (before && PREPOSITIONS.includes(before.toLowerCase())) continue;
        if (!isVerb(verb)) continue;
        const rest = out.slice(end).match(/^[^,;:.]*/)[0];
        const agreed = `${agree(verb)}${joinedVerbs(rest)}`;
        out = out.slice(0, end - verb.length) + agreed + out.slice(end + rest.length);
        subject.lastIndex = end - verb.length + agreed.length;
      }
      return out;
    };

    // "it" and "its" become "they", "them" and "their" when they mean the plants: in a sentence
    // that carries on about them (about), or after one of the marked plural nouns. "it" stops
    // meaning the plants when another noun it could stand for comes up ("check the compost ...
    // once it has dried", "a length of bare stem ... a section of it"), and once an "it" means
    // something else, the rest of the sentence keeps "it" and "its" too ("tip the container on
    // its side"). Until then "its" goes on meaning the plants ("a length of bare stem beneath
    // its rosettes"). "it" is the subject when it starts a clause or a verb follows it, and
    // the object anywhere else.
    const pronouns = (text, about) => {
      let plants = about;
      let seen = about;
      let other = false;
      const things = `\\b(?:the|a|an|this|that)\\s+${MODIFIER}{0,2}?(?:${NOT_PLANT.join('|')})\\b|\\b(?:${PARTS.join('|')})\\b`;
      const pattern = new RegExp(`\u0001|\\b([Ii]ts)\\b|\\b([Ii]t)\\b(?!['’])(?:(${ADVERBS})(\\s+)(\\w+))?|${things}`, 'g');
      return text.replace(pattern, (m, its, it, gap = '', space = '', next = '', offset, whole) => {
        if (m === '\u0001') {
          plants = seen = true;
          return m;
        }
        if (!its && !it) {
          plants = false;
          return m;
        }
        if (its) return seen && !other ? (its === 'Its' ? 'Their' : 'their') : m;
        if (!plants || other) {
          other = true;
          return m;
        }
        const before = whole.slice(0, offset).trimEnd();
        const starts = !before || /[\u0002,;:]$/.test(before) || CLAUSE_STARTS.includes(before.split(/\s+/).pop().toLowerCase());
        if (next && (starts || isVerb(next))) return `${it === 'It' ? 'They' : 'they'}${gap}${space}${agree(next)}`;
        if (!next) return 'them';
        return `${it === 'It' ? 'Them' : 'them'}${gap}${space}${next}`;
      });
    };

    // about: 'paragraph' when an earlier sentence in the paragraph names [plant], 'topic' when
    // only an earlier paragraph of the topic does. genera: the genera of the plants in the
    // group, so "a compact branching Aeonium" can become plural.
    function groupSentence(sentence, about, genera = new Set()) {
      let out;
      if (OWN_PAGE.test(sentence) && EACH.test(sentence)) {
        out = sentence.replace(new RegExp(EACH.source, 'g'), (m) => (m === "the product's" ? "each plant's" : 'each plant'));
        return capital(out);
      }
      if (sentence.includes('[plant]')) {
        // \u0004 marks the end of the verb after "your plants", where joinedVerbs starts.
        out = sentence.replace(/\[plant\]['’]s\b/g, "\u0001your plants'").replace(/\[plant\](\s+)(\w+)/g, (m, space, next, offset, whole) => {
          const before = whole.slice(0, offset).trim().split(/\s+/).pop()?.toLowerCase() || '';
          if (isVerb(next) && !OBJECT_VERBS.includes(before.replace(/[^a-z]/g, ''))) {
            return `\u0001your plants${space}${plural(next)}\u0004`;
          }
          return `[obj]${space}${next}`;
        });
        out = out
          .replace(/\u0004([^,;:.]*)/g, (m, rest) => joinedVerbs(rest))
          .replace(/(\w+)\s+\[obj\]|\[obj\]/g, (m, before) => {
            const word = (before || '').toLowerCase();
            if (!before) return '\u0001your plants';
            if (word === 'planted') return `${before} \u0001plants`;
            if (OBJECT_VERBS.includes(word)) return `${before} \u0001them`;
            return `${before} \u0001your plants`;
          })
          .replace(/\[plant\]/g, '\u0001your plants');
        out = pronouns(pluralNouns(out, genera), true);
      } else {
        // A sentence that carries on about the plant without naming it. Telling the shopper what
        // to do with "it" does so anywhere in the topic ("Unpack it carefully", "Settle it in",
        // "introduce it to stronger sun"), and so does "Once established, it". A sentence that
        // opens with "It" does so only straight after the plant is named, since "It is always
        // best to water in the mornings" is not about the plant.
        const handling = new RegExp(
          `^(?:Being frost-tender, )?(?:Carefully )?(?:${OBJECT_VERBS.join('|')})\\s+(?:it|the plant)\\b|^Once \\w+,? it\\b|\\b(?:${HANDLING.join('|')}) it\\b`,
          'i'
        );
        const carriesOn =
          (about && handling.test(sentence)) ||
          (about === 'paragraph' && /^(?:Being frost-tender, )?[Ii]t\b|^As .*\bincrease,? it\b|\bit is not hardy\b|^In its native\b/.test(sentence));
        out = pronouns(pluralNouns(sentence, genera), carriesOn);
      }
      return capital(out.replace(/[\u0001\u0002]/g, ''));
    }

    // Words for parts that only some plants have, and wording about a single species. A mixed
    // group keeps a sentence with a part in it only if every plant's own care profile
    // mentions that part.
    const SPECIFIC_PARTS = [
      /\brosettes?\b/i,
      /\bheads?\b/i,
      /\btrunks?\b/i,
      /\boffsets?\b/i,
      /\bflower spikes?\b/i,
      /\bfarina\b/i,
      /\bvariegat|\bpale areas\b/i,
      /\bflat\b/i,
      /\bbush(?:es|y)?\b/i,
      /\bclumps?\b/i,
      /\bmats?\b/i,
    ];
    const ONE_SPECIES = /\b(?:[Tt]his|[Aa]s an?(?:\s+[a-z-]+)*)\s+species\b/;

    // For a group whose plants don't all use the care profile a sentence comes from: the
    // sentence, cut short before any clause (after a semicolon) that suits only some of them,
    // or '' if its opening does. A clause suits only some of the plants when it names a genus
    // they don't all belong to (known: every genus in the shop), talks about one species, or
    // names a part (SPECIFIC_PARTS) one of their own profiles never mentions (profileText).
    const suitsAll = (sentence, plants, known, profileText) => {
      const fits = (clause) => {
        for (const word of clause.match(/\b[A-Z][a-z]+\b/g) || []) {
          const name = known.has(word) ? word : word.replace(/s$/, '');
          if (known.has(name) && !plants.every((plant) => genus(plant.title) === name)) return false;
        }
        if (ONE_SPECIES.test(clause)) return false;
        return SPECIFIC_PARTS.every((part) => !part.test(clause) || plants.every((plant) => part.test(profileText(plant))));
      };
      const clauses = sentence.split(/;\s+/);
      let kept = 0;
      while (kept < clauses.length && fits(clauses[kept])) kept++;
      if (kept === clauses.length) return sentence;
      if (!kept) return '';
      return `${clauses.slice(0, kept).join('; ').replace(/[,;:]?\s*$/, '')}.`;
    };

    const routes = () => window.Theme?.routes || {};
    const cartJsUrl = () => `${routes().cart_url || '/cart'}.js`;

    // Contact form fields kept in sessionStorage in case sending fails (see keepContact()).
    const CONTACT_STORAGE_KEY = 'ss-plant-finder-contact';
    const CONTACT_KEPT = ['name', 'phone'];

    /**
     * Steps through the questions one at a time and ranks the plants against the answers.
     * Plant data loads once, on the first answer, from the collection's plant-finder-data
     * view (up to 250 plants a page). Browse results have an add to cart button each; the
     * plants the finder picks itself ("Choose for me" and the planter mix) only go in the
     * cart together, from Add all to cart.
     */
    class SsPlantFinder extends HTMLElement {
      connectedCallback() {
        this.text = JSON.parse(this.querySelector('[data-text]').textContent);
        this.factIcons = this.querySelector('[data-fact-icons]').content;
        this.results = this.querySelector('[data-results]');
        this.grid = this.querySelector('[data-grid]');
        this.status = this.querySelector('[data-status]');
        this.more = this.querySelector('[data-more-actions]');
        this.choosePanel = this.querySelector('[data-choose-panel]');
        this.chooseInput = this.querySelector('[data-choose-count]');
        this.chooseInput.max = MAX_CHOOSE;
        this.soldOut = this.querySelector('[data-include-sold-out]');
        this.picked = this.querySelector('[data-picked]');
        this.care = this.querySelector('[data-care]');
        this.planting = this.querySelector('[data-planting]');
        this.discountCode = this.dataset.discountCode || '';
        this.pageSize = Number(this.dataset.pageSize) || 12;
        this.answers = {};
        this.route = 'spot';
        this.current = 0;

        this.dialog = this.querySelector('[data-dialog]');
        this.dialogBody = this.querySelector('[data-dialog-body]');

        this.contact = this.querySelector('[data-contact]');
        this.cuttings = this.querySelector('[data-cuttings]');
        this.cuttingsBundle = JSON.parse(this.querySelector('[data-cuttings-bundle]').textContent);

        this.handleClick = (event) => this.onClick(event);
        this.handleInput = (event) => {
          if (event.target.matches('[data-long-planter]')) this.showSizeFields();
          else if (event.target.closest('[data-sizes]')) this.checkSize();
          else if (event.target.closest('[data-area-sizes]')) this.checkAreaSize();
        };
        this.handleSoldOut = () => this.render();
        this.handleSubmit = (event) => {
          if (event.target.matches('#ss-plant-finder-contact')) this.keepContact(event.target);
        };
        // Closing by Esc or the close button gives the page its scrolling back, and drops a
        // #start from the address so a refresh shows the page rather than the finder.
        this.handleClose = () => {
          document.documentElement.classList.remove('ss-finder-open');
          if (window.location.hash === '#start') history.replaceState(null, '', window.location.pathname + window.location.search);
        };
        this.addEventListener('click', this.handleClick);
        this.addEventListener('input', this.handleInput);
        this.addEventListener('submit', this.handleSubmit);
        this.soldOut.addEventListener('change', this.handleSoldOut);
        this.dialog.addEventListener('close', this.handleClose);
        this.show(0, false);

        // Back from sending the contact form: show the thank you or the errors.
        if (this.querySelector('[data-contact-sent], [data-contact-errors]')) {
          // The contact form serves planters and outdoor areas; we keep which one it was sent from.
          this.route = this.keptRoute() === 'area' ? 'area' : 'planter';
          if (this.querySelector('[data-contact-errors]')) this.restoreContact();
          else this.forgetContact();
          this.current = 1;
          this.view('contact');
          this.open();
          return;
        }

        // Links ending #start (the homepage panel's button) open straight into the questions,
        // as does the open_on_load setting. Never in the theme editor.
        const startNow = this.dataset.openOnLoad === 'true' || window.location.hash === '#start';
        if (startNow && !window.Shopify?.designMode) this.open();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('input', this.handleInput);
        this.removeEventListener('submit', this.handleSubmit);
        this.soldOut.removeEventListener('change', this.handleSoldOut);
        this.dialog.removeEventListener('close', this.handleClose);
        if (this.dialog.open) this.dialog.close();
      }

      // Opens the finder full screen, where the shopper left off.
      open() {
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('ss-finder-open');
        const heading = this.dialog.querySelector('[data-step]:not([hidden]) legend, .ss-finder__results:not([hidden]) h3');
        if (heading) this.focusTop(heading);
      }

      step(name) {
        return this.querySelector(`[data-step="${name}"]`);
      }

      // The answer to where the plants will live, for the chosen route.
      get place() {
        return this.answers[PLACE_STEPS[this.route]];
      }

      // The questions for the chosen route, in order.
      get flow() {
        const place = this.place;
        const staysOut = place && !place.dataset.temp;
        return FLOWS[this.route].filter((name) => (name === 'temp' ? staysOut : this.step(name)));
      }

      // An answer, only if its question is on the chosen route. Answers from another route
      // stay in place in case the shopper goes back, but don't count.
      answer(name) {
        return this.flow.includes(name) ? this.answers[name] : undefined;
      }

      get indoor() {
        return Boolean(this.place?.hasAttribute('data-indoor'));
      }

      onClick(event) {
        if (event.target.closest('[data-open]')) return this.open();
        if (event.target.closest('[data-close]')) return this.dialog.close();
        const option = event.target.closest('.ss-finder__option');
        if (option) return this.choose(option);
        const add = event.target.closest('[data-add]');
        if (add) return this.addOne(add);
        if (event.target.closest('[data-show-results]')) return this.finish();
        if (event.target.closest('[data-choose]')) return this.pick(this.chooseCount());
        const qty = event.target.closest('[data-qty]');
        if (qty) return this.setChooseCount(this.chooseCount() + Number(qty.dataset.qty));
        if (event.target.closest('[data-size-next]')) return this.sizeNext();
        if (event.target.closest('[data-area-size-next]')) return this.areaSizeNext();
        if (event.target.closest('[data-planter-mix]')) return this.pick(this.planterCount());
        const addAll = event.target.closest('[data-add-all]');
        if (addAll) return addAll.dataset.view ? this.openCart() : this.addAll(addAll);
        if (event.target.closest('[data-reshuffle]')) return this.pick(this.lastCount, { another: true });
        if (event.target.closest('[data-see-all]')) return this.finish();
        // Plants we picked from the results go back to the results; a planter mix to its questions.
        if (event.target.closest('[data-back]')) {
          return !this.picked.hidden && this.route !== 'planter' ? this.finish() : this.show(this.current - 1);
        }
        if (event.target.closest('[data-more]')) return this.render(this.visible + this.pageSize);
        if (event.target.closest('[data-restart]')) return this.restart();
      }

      choose(option) {
        // Start loading the plants early; finish() reports any failure.
        this.load().catch(() => {});
        const step = option.closest('[data-step]');
        const name = step.dataset.step;
        if (step.hasAttribute('data-multiple')) {
          option.setAttribute('aria-pressed', option.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          return;
        }
        step.querySelectorAll('.ss-finder__option').forEach((el) => el.classList.toggle('is-selected', el === option));
        this.answers[name] = option;

        if (name === 'route') this.route = option.dataset.route;
        this.show(this.current + 1);
      }

      // Shows one part of the panel: a question ('step'), the results ('results'), the plants
      // picked for the shopper ('picked'), the contact form ('contact') or the cuttings
      // bundle ('cuttings').
      view(name) {
        // Results, picks and care tips still loading for the last screen are dropped when they
        // arrive: finish() and pick() check screen, and renderCare() its careToken.
        this.screen = (this.screen || 0) + 1;
        this.careToken = (this.careToken || 0) + 1;
        const current = this.flow[this.current];
        this.querySelectorAll('.ss-finder__step').forEach((step) => {
          step.hidden = !(name === 'step' && step.dataset.step === current);
        });
        this.results.hidden = name !== 'results';
        this.picked.hidden = name !== 'picked';
        this.contact.hidden = name !== 'contact';
        this.cuttings.hidden = name !== 'cuttings';
        // Care tips show again once the results they belong to have rendered.
        if (name !== 'results' && name !== 'picked') this.care.hidden = true;
        if (name !== 'picked') this.planting.hidden = true;
        this.querySelector('[data-progress]').hidden = name !== 'step';
        this.querySelector('[data-nav]').hidden = name === 'step' && this.current === 0;
        this.querySelectorAll('[data-route-only]').forEach((el) => (el.hidden = !el.dataset.routeOnly.split(' ').includes(this.route)));
      }

      show(index, focus = true) {
        const flow = this.flow;
        this.current = Math.min(Math.max(0, index), flow.length - 1);
        this.view('step');
        this.showSunOptions();
        this.querySelector('[data-step-number]').textContent = this.current + 1;
        this.querySelector('[data-step-total]').textContent = flow.length;
        this.querySelector('[data-bar]').style.width = `${((this.current + 1) / flow.length) * 100}%`;
        if (focus) this.focusTop(this.step(flow[this.current]).querySelector('legend'));
      }

      // Grow lights are an answer only indoors. A bright room, away from the window, asks
      // only about grow lights, with them first, instead of which way it faces. Changing the
      // place clears a light answer that no longer shows.
      showSunOptions() {
        const step = this.step('sun');
        const brightRoom = this.route === 'spot' && Boolean(this.answers.locations?.hasAttribute('data-bright-room'));
        step.classList.toggle('is-bright-room', brightRoom);
        step.querySelector('[data-sun-question]').hidden = brightRoom;
        step.querySelector('[data-bright-room-question]').hidden = !brightRoom;
        step.querySelectorAll('[data-sun]').forEach((option) => {
          if (option.hasAttribute('data-grow-lights')) option.hidden = !this.indoor;
          else if (option.hasAttribute('data-no-grow-lights')) option.hidden = !brightRoom;
          else option.hidden = brightRoom;
        });
        if (this.answers.sun?.hidden) {
          this.answers.sun.classList.remove('is-selected');
          delete this.answers.sun;
        }
      }

      // A long planter takes a length and a width instead of a diameter.
      showSizeFields() {
        const long = this.querySelector('[data-long-planter]').checked;
        this.querySelectorAll('[data-for-shape]').forEach((field) => (field.hidden = (field.dataset.forShape === 'long') !== long));
        this.checkSize();
      }

      // The planter's top area (cm²), narrowest width (cm) and a description, or null until
      // its sizes are in.
      get planterSize() {
        const value = (name) => {
          const number = Number(this.querySelector(`[data-dimension="${name}"]`).value);
          return number > 0 ? number : 0;
        };
        const t = this.text;
        if (this.querySelector('[data-long-planter]').checked) {
          const length = value('length');
          const width = value('width');
          if (!length || !width) return null;
          return {
            area: length * width,
            narrowest: Math.min(length, width),
            largest: Math.max(length, width),
            summary: t.size_long.replace('[length]', length).replace('[width]', width),
          };
        }
        const diameter = value('diameter');
        if (!diameter) return null;
        return {
          area: Math.PI * (diameter / 2) ** 2,
          round: true,
          narrowest: diameter,
          largest: diameter,
          summary: t.size_round.replace('[diameter]', diameter),
        };
      }

      checkSize() {
        const next = this.querySelector('[data-size-next]');
        if (next) next.disabled = !this.planterSize;
      }

      // Plants for the planter at the fullness chosen (DENSITY), never 2 or 4 (AVOID_COUNTS):
      // 2 goes up to 3, and 4 goes to 3 or 5, whichever is nearer.
      planterCount() {
        const density = this.answers['planter-density']?.dataset.density;
        const width = Math.sqrt(this.planterSize?.area || 0) / 10;
        const exact = width * (DENSITY[density] || DENSITY.balanced);
        const count = Math.max(1, Math.round(exact));
        if (count === 2) return 3;
        if (count === 4) return exact < 4 ? 3 : 5;
        return count;
      }

      // Sizes in: carry on, offer the contact form for areas too big to plant from the shop,
      // or the cuttings bundle for pots too small for a mix.
      sizeNext() {
        const size = this.planterSize;
        if (!size) return;
        const tooBig = size.round ? size.narrowest > MAX_ROUND_DIAMETER : size.area > MAX_PLANTER_AREA;
        if (tooBig) return this.showContact();
        if (this.showCuttings(size)) return;
        this.show(this.current + 1);
      }

      // An outdoor area's size (cm²) and a description, or null until both measurements are in.
      get areaSize() {
        const value = (name) => {
          const number = Number(this.querySelector(`[data-area-dimension="${name}"]`).value);
          return number > 0 ? number : 0;
        };
        const length = value('length');
        const width = value('width');
        if (!length || !width) return null;
        return {
          area: length * width,
          summary: this.text.size_area.replace('[length]', length).replace('[width]', width),
        };
      }

      checkAreaSize() {
        const next = this.querySelector('[data-area-size-next]');
        if (next) next.disabled = !this.areaSize;
      }

      // An area over MAX_GARDEN_AREA goes to the contact form; one up to it carries on.
      areaSizeNext() {
        const size = this.areaSize;
        if (!size) return;
        if (size.area > MAX_GARDEN_AREA) return this.showContact();
        this.show(this.current + 1);
      }

      // The shopper ticked fleece for an outdoor area (it only counts once the cold is asked).
      get fleece() {
        return this.route === 'area' && Boolean(this.answer('temp')) && this.querySelector('[data-fleece]').checked;
      }

      // Shows the cuttings bundle in the size for the pot. Returns false, so the questions
      // carry on, when the pot is big enough for a mix or the right size isn't for sale.
      showCuttings(size) {
        const t = this.text;
        const band = CUTTINGS_SIZES.find((entry) => size.largest < entry.under);
        const bundle = this.cuttingsBundle;
        const variant = band && bundle?.variants.find((v) => v.available && parseFloat(v.title) === band.cm);
        if (!variant) return false;

        this.current = this.flow.indexOf('planter-size') + 1;
        this.view('cuttings');
        this.renderSummary(this.cuttings.querySelector('[data-cuttings-summary]'));
        const plant = {
          title: bundle.title,
          url: `${bundle.url}?variant=${variant.id}`,
          image: bundle.image,
          alt: bundle.alt,
          available: true,
          variant_id: variant.id,
          variant_price: variant.price,
          variant_title: t.cuttings_size.replace('[size]', variant.title),
          min_temp: null,
        };
        this.cuttings.querySelector('[data-cuttings-grid]').replaceChildren(this.card(plant));
        this.focusTop(this.cuttings.querySelector('h3'));
        return true;
      }

      showContact() {
        const t = this.text;
        const area = this.route === 'area';
        this.current = this.flow.indexOf(area ? 'area-size' : 'planter-size') + 1;
        this.view('contact');
        const body = this.querySelector('[data-contact-body]');
        if (body) {
          const details = [
            area ? this.areaSize?.summary : this.planterSize?.summary,
            this.place?.dataset.summary,
            this.answer('sun')?.dataset.summary,
            this.answer('temp')?.dataset.summary,
            this.fleece ? t.fleece_summary : null,
          ].filter(Boolean);
          body.value = [t.contact_body, '', ...details].join('\n');
        }
        this.focusTop(this.contact.querySelector('h3'));
      }

      // After an error, the form fills the email and message back in from Shopify's form
      // object. Shopify documents no name or phone on the contact form, so we keep our own
      // copy of those when the shopper sends it. If storage is blocked, they type them again.
      keepContact(form) {
        try {
          const fields = Object.fromEntries(CONTACT_KEPT.map((name) => [name, form.elements[`contact[${name}]`]?.value || '']));
          sessionStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify({ ...fields, route: this.route }));
        } catch (error) {}
      }

      // The route the contact form was sent from, if we kept it.
      keptRoute() {
        try {
          return JSON.parse(sessionStorage.getItem(CONTACT_STORAGE_KEY) || '{}').route;
        } catch (error) {
          return undefined;
        }
      }

      // Fills in the kept name and phone after an error, leaving anything already there.
      restoreContact() {
        const form = this.querySelector('#ss-plant-finder-contact');
        try {
          const fields = JSON.parse(sessionStorage.getItem(CONTACT_STORAGE_KEY) || '{}');
          CONTACT_KEPT.forEach((name) => {
            const input = form?.elements[`contact[${name}]`];
            if (input && !input.value && typeof fields[name] === 'string') input.value = fields[name];
          });
        } catch (error) {}
      }

      // Once the message has gone, the kept name and phone aren't needed.
      forgetContact() {
        try {
          sessionStorage.removeItem(CONTACT_STORAGE_KEY);
        } catch (error) {}
      }

      // How many plants "Choose for me" picks: the box under the results, 1 to MAX_CHOOSE.
      chooseCount() {
        const count = Math.round(Number(this.chooseInput.value));
        return Math.min(MAX_CHOOSE, Math.max(1, Number.isFinite(count) && count ? count : 1));
      }

      setChooseCount(count) {
        this.chooseInput.value = Math.min(MAX_CHOOSE, Math.max(1, count));
      }

      restart() {
        this.answers = {};
        this.route = 'spot';
        this.querySelectorAll('[data-dimension], [data-area-dimension]').forEach((input) => (input.value = ''));
        this.querySelector('[data-fleece]').checked = false;
        this.checkAreaSize();
        this.querySelector('[data-long-planter]').checked = false;
        this.showSizeFields();
        this.querySelectorAll('.ss-finder__option').forEach((el) => {
          el.classList.remove('is-selected');
          if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', 'false');
        });
        this.soldOut.checked = false;
        this.show(0);
      }

      async finish() {
        this.current = this.flow.length;
        this.view('results');
        const screen = this.screen;
        this.renderSummary(this.querySelector('[data-summary-list]'));
        this.grid.replaceChildren();
        this.more.hidden = true;
        this.choosePanel.hidden = true;
        this.status.textContent = this.text.loading;
        this.focusTop(this.results.querySelector('h3'));

        try {
          this.plants = await this.load();
        } catch (error) {
          this.status.textContent = this.text.error;
          return;
        }
        // Rendering now would bring the care tips back over the shopper's new screen.
        if (screen !== this.screen) return;
        this.render();
      }

      // Moves focus to the new question or the results. Full screen, each one starts at the
      // top. In the page, it only scrolls when that heading is out of sight, and then just
      // far enough to show the top of the panel.
      focusTop(target) {
        target.focus({ preventScroll: true });
        if (this.dialog.open) {
          this.dialogBody.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        const { top, bottom } = target.getBoundingClientRect();
        if (top >= header && bottom <= window.innerHeight) return;
        const panelTop = this.querySelector('.ss-finder__panel').getBoundingClientRect().top;
        window.scrollBy({ top: panelTop - header - 12, behavior: 'smooth' });
      }

      load() {
        if (!this.loading) {
          const url = this.dataset.url;
          // A page that has dropped out of Shopify's cache can time out, so try each once more.
          const page = (n, retry = true) =>
            fetch(`${url}&page=${n}`)
              .then((response) => {
                if (!response.ok) throw new Error(`Plant finder data: ${response.status}`);
                return response.json();
              })
              .catch((error) => {
                if (!retry) throw error;
                return new Promise((resolve) => setTimeout(resolve, 800)).then(() => page(n, false));
              });
          this.loading = page(1)
            .then(async (first) => {
              const rest = [];
              for (let n = 2; n <= first.pages; n++) rest.push(page(n));
              const pages = [first, ...(await Promise.all(rest))];
              // Plants over the section's highest price (by the pot size Add to cart uses)
              // never show. The limit is in pounds, so it's converted to the shopper's
              // currency, which the data's prices are in.
              const rate = Number(window.Shopify?.currency?.rate) || 1;
              const maxCents = Number(this.dataset.maxPrice) * 100 * rate || Infinity;
              return pages
                .flatMap((p) => p.products)
                .filter((plant) => !(plant.variant_cents > maxCents))
                .map((plant, index) => ({ ...plant, index }));
            })
            .catch((error) => {
              this.loading = null;
              throw error;
            });
        }
        return this.loading;
      }

      criteria() {
        const a = Object.fromEntries(this.flow.map((name) => [name, this.answer(name)]));
        const planter = this.route === 'planter';
        const place = this.place;
        const growLights = a.sun?.dataset.sun === 'lights';
        const colours = [...this.step('colours').querySelectorAll('[aria-pressed="true"]')].flatMap((el) =>
          list(el.dataset.colours)
        );
        const size = planter ? 0 : Number(a.size?.dataset.size) || 0;
        // The next size answer down, so "Up to 40 cm" covers plants over 20 cm and up to 40 cm.
        const sizeFloor = Math.max(
          0,
          ...[...this.step('size').querySelectorAll('[data-size]')].map((el) => Number(el.dataset.size)).filter((n) => n < size)
        );
        // The wider size answers, smallest first, so a loosened size widens one answer at a time.
        const sizeSteps = [...this.step('size').querySelectorAll('[data-size]')]
          .map((el) => Number(el.dataset.size))
          .filter((n) => n > size)
          .sort((x, y) => x - y);
        let temp = place?.dataset.temp ?? a.temp?.dataset.temp;
        temp = temp !== undefined ? Number(temp) : null;
        // Fleece protects an outdoor area's plants by FLEECE_DEGREES, up to frost-free.
        if (this.fleece && temp !== null && temp < 5) temp = Math.min(temp + FLEECE_DEGREES, 5);
        return {
          // With grow lights, light no longer limits an indoor plant, so any indoor plant fits.
          locations: growLights && this.indoor ? INDOOR_PLACES : list(place?.dataset.locations),
          outdoor: Boolean(place?.hasAttribute('data-outdoor')),
          sun: growLights ? 0 : Number(a.sun?.dataset.sun) || 0,
          temp,
          levels: list(a.levels?.dataset.levels),
          forms: list(a['area-role']?.dataset.forms),
          size,
          sizeFloor,
          sizeSteps,
          width: planter ? this.planterSize?.narrowest || 0 : 0,
          planter,
          colours,
        };
      }

      // Returns how closely the plant fits the answers, or null when it should not be shown.
      // Sun counts most. A loosened answer no longer rules plants out, but the plants that
      // still meet it keep its points, so they come first.
      // loose holds the loosened answers (names), and how far the winter temperature (temp,
      // degrees), a planter's width (width, a multiple) and the room (size, cm) are loosened.
      score(plant, c, loose) {
        const relaxed = loose.names;
        let score = 0;
        if (c.temp !== null) {
          const over = plant.min_temp === null ? Infinity : plant.min_temp - c.temp;
          if (over > loose.temp) return null;
          // A plant rated warmer than the answer comes after every plant that's hardy enough.
          if (over > 0) score -= 20 * over;
        }

        if (c.planter) {
          // Every plant has to fit across the planter. Tall Aeoniums never go in a mixed
          // planter, and small planters leave Aeoniums out altogether (AEONIUM_GENERA).
          if (c.width) {
            if (!plant.spread_cm || plant.spread_cm > c.width * loose.width) return null;
            if (plant.spread_cm > c.width) score -= 10 * (plant.spread_cm / c.width - 1);
          }
          if (AEONIUM_GENERA.includes(genus(plant.title))) {
            if (!plant.height_cm || plant.height_cm > AEONIUM_MAX_HEIGHT) return null;
            if (c.width && c.width <= SMALL_PLANTER) return null;
          }
        }

        let sun = sunLevel(plant.sunlight);
        if (c.sun === 1 && sun === 3 && NORTH_FACING_GENERA.includes(genus(plant.title))) sun = 2;
        if (c.sun && sun) {
          const gap = Math.abs(c.sun - sun);
          if (gap > 1 && !relaxed.has('sun')) return null;
          score += gap === 0 ? 6 : gap === 1 ? 1 : 0;
        }

        if (c.locations.length) {
          // A plant listed for more of the chosen places (patio, balcony, table) fits better.
          const hits = (plant.locations || []).filter((l) => c.locations.includes(l)).length;
          if (hits) score += 3 + hits / c.locations.length;
          else if (c.outdoor) score += (plant.locations || []).some((l) => OUTDOOR_PLACES.includes(l)) ? 1.5 : 0;
          else if (!relaxed.has('locations')) return null;
        }

        if (c.levels.length) {
          if (c.levels.includes(plant.growability)) {
            score += 3;
            // Plants at the grower's own level before easier ones.
            if (plant.growability === c.levels.at(-1)) score += 0.5;
          } else if (!relaxed.has('levels')) return null;
        }

        if (c.forms.length) {
          if (hasForm(plant, c.forms)) score += 3;
          else if (!relaxed.has('forms')) return null;
        }

        if (c.size) {
          const largest = Math.max(plant.height_cm || 0, plant.spread_cm || 0);
          if (largest && largest <= c.size) {
            score += 3;
            // Plants that fill the room they've described before much smaller ones.
            if (largest > c.sizeFloor) score += 1;
          } else if (!relaxed.has('size') || (largest || Infinity) > loose.size) return null;
        }

        if (c.colours.length && plant.colours?.length) {
          // How much of the plant is in the chosen colours.
          const shared = plant.colours.filter((colour) => c.colours.includes(colour)).length;
          score += (4 * shared) / plant.colours.length;
        }
        return score;
      }

      // Ranks the pool, closest match first. Answers are loosened (see RELAX_ORDER) until at
      // least minResults plants fit, but the winter temperature only until minSafe do.
      match(pool, c, minResults = MIN_RESULTS, minSafe = minResults) {
        const loose = { names: new Set(), temp: 0, width: 1, size: Infinity };
        const rank = () =>
          pool
            .map((plant) => ({ plant, score: this.score(plant, c, loose) }))
            .filter((r) => r.score !== null)
            // Equal matches keep the data's order, which is best-selling first.
            .sort((x, y) => y.score - x.score || x.plant.index - y.plant.index);

        let ranked = rank();
        // Light is loosened by how many plants suit the light, place and winter temperature
        // only, with the rest of the answers left out (see SUN_RELAX_BELOW).
        const spot = { ...c, size: 0, levels: [], forms: [], colours: [], planter: false, width: 0 };
        const suitSpot = () => pool.filter((plant) => this.score(plant, spot, loose) !== null).length;
        if (c.sun && suitSpot() < Math.max(SUN_RELAX_BELOW, minResults)) {
          loose.names.add('sun');
          ranked = rank();
        }
        for (const name of RELAX_ORDER) {
          if (ranked.length >= minResults) break;
          // "Any size" (0) and empty lists rule nothing out, so there is nothing to loosen.
          if (!(name === 'size' ? c.size : c[name].length)) continue;
          // Outdoors, the place never rules a plant out, so there is nothing to loosen.
          if (name === 'locations' && c.outdoor) continue;
          loose.names.add(name);
          if (name === 'size') {
            // One size answer up at a time, then any size, so "Up to 20 cm" never shows more
            // plants than "Up to 40 cm" would.
            for (const limit of [...c.sizeSteps, Infinity]) {
              loose.size = limit;
              ranked = rank();
              if (ranked.length >= minResults) break;
            }
          } else {
            ranked = rank();
          }
        }
        for (const width of c.width ? WIDTH_FUZZ : []) {
          if (ranked.length >= minResults) break;
          loose.width = width;
          ranked = rank();
        }
        while (c.temp !== null && ranked.length < minSafe && loose.temp < TEMP_FUZZ) {
          loose.temp += 1;
          loose.names.add('temp');
          ranked = rank();
        }
        // Light is loosened silently, and a planter's width doesn't show in the note.
        return { ranked, matches: ranked.map((r) => r.plant), relaxed: [...loose.names].filter((name) => name !== 'sun') };
      }

      // Picks one plant for each role from the closest matches. Each pick is the plant
      // that adds most variety to the ones already chosen: a genus they don't have yet,
      // new colours, a different size. Between equally varied plants the closer match
      // wins. A role with no plant left takes any other.
      // avoid counts how often each plant has been shown already; "Try another mix" moves
      // further from a plant each time it has been in a mix.
      pickVaried(ranked, roles, avoid = new Map()) {
        const pool = ranked.slice(0, Math.max(roles.length * PICK_POOL_PER_PLANT, 24));
        const best = pool[0]?.score ?? 0;
        const genera = new Map();
        const forms = new Map();
        const colours = new Set();
        const sizes = new Set();
        const picked = [];

        for (const role of roles) {
          const free = (r) => !picked.includes(r.plant);
          let candidates = [];
          if (role) {
            // Role plants are rarer than the closest matches overall, so look further for them.
            for (const form of [role, ...ROLE_FALLBACKS[role]]) {
              candidates = ranked.filter((r) => free(r) && hasForm(r.plant, ROLES[form])).slice(0, PICK_POOL_PER_PLANT * 4);
              if (candidates.length) break;
            }
          }
          if (!candidates.length) {
            candidates = pool.filter((r) => free(r) && !(role === 'tall' && hasForm(r.plant, ROLES.trailing)));
          }
          if (!candidates.length) break;

          const tallest = Math.max(1, ...candidates.map((r) => r.plant.height_cm || 0));
          let top = candidates[0];
          let topValue = -Infinity;
          for (const r of candidates) {
            const { plant, score } = r;
            const newColours = (plant.colours || []).filter((colour) => !colours.has(colour)).length;
            // A genus already in the pack costs the most, so a second of one only comes in
            // when it is a much closer match than anything new.
            let value =
              8 / (1 + (genera.get(genus(plant.title)) || 0)) ** 2 +
              2 / (1 + (forms.get(plant.form?.[0]) || 0)) +
              Math.min(newColours, 2) +
              (sizes.has(sizeBand(plant)) ? 0 : 1) +
              (score - best) * 0.5;
            // The centrepiece should be the tallest plant that fits.
            if (role === 'tall') value += (3 * (plant.height_cm || 0)) / tallest;
            value -= 6 * (avoid.get(plant.id) || 0);
            if (value > topValue) {
              topValue = value;
              top = r;
            }
          }

          const { plant } = top;
          picked.push(plant);
          // The middle plant is the centrepiece; the others are labelled by their own form.
          if (role === 'tall') plant.role = 'tall';
          else plant.role = role ? formRole(plant) : null;
          genera.set(genus(plant.title), (genera.get(genus(plant.title)) || 0) + 1);
          forms.set(plant.form?.[0], (forms.get(plant.form?.[0]) || 0) + 1);
          (plant.colours || []).forEach((colour) => colours.add(colour));
          sizes.add(sizeBand(plant));
        }
        return picked;
      }

      // The answers (of match()'s relaxed) that at least one of the plants on show doesn't
      // meet. An answer loosened without letting in a single plant that misses it isn't one.
      shownRelaxed(relaxed, plants, c) {
        const misses = {
          size: (plant) => {
            const largest = Math.max(plant.height_cm || 0, plant.spread_cm || 0);
            return !(largest && largest <= c.size);
          },
          forms: (plant) => !hasForm(plant, c.forms),
          levels: (plant) => !c.levels.includes(plant.growability),
          locations: (plant) => !(plant.locations || []).some((l) => c.locations.includes(l)),
          temp: (plant) => plant.min_temp === null || plant.min_temp > c.temp,
        };
        return relaxed.filter((name) => !misses[name] || plants.some(misses[name]));
      }

      // The sentence naming the loosened answers that the plants on show don't meet (see
      // shownRelaxed), or '' if there are none. The results use the relaxed text and the
      // picked plants picked_relaxed.
      relaxedNote(relaxed, plants, c, sentence = this.text.relaxed) {
        relaxed = this.shownRelaxed(relaxed, plants, c);
        if (!relaxed.length) return '';
        const names = relaxed.map((name) => this.text[`relaxed_${name}`]);
        const joined = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names.at(-1)}` : names[0];
        return sentence.replace('[relaxed]', joined);
      }

      render(visible = this.pageSize) {
        if (!this.plants) return;
        const c = this.criteria();
        const inStockOnly = !this.soldOut.checked;
        const pool = this.plants.filter((p) => p.locations && (!inStockOnly || p.available));
        const { matches, relaxed } = this.match(pool, c);
        this.visible = visible;

        const t = this.text;
        let message;
        if (!matches.length) {
          message = t.none.replace('[help]', t.help_url);
        } else {
          const key = (matches.length === 1 ? 'found_one' : 'found_many') + (inStockOnly ? '_in_stock' : '');
          message = t[key].replace('[count]', matches.length);
          const note = this.relaxedNote(relaxed, matches, c);
          if (note) message += ' ' + note;
        }
        this.status.innerHTML = message;

        this.grid.replaceChildren(...matches.slice(0, visible).map((plant) => this.card(plant)));
        this.more.hidden = matches.length <= visible;
        // Choose for me picks from in-stock plants, so it shows when some are in stock.
        this.choosePanel.hidden = !matches.some((plant) => plant.available && plant.variant_id);
        this.renderCare(matches.slice(0, visible));
      }

      renderSummary(target) {
        const labels = this.flow
          .filter((name) => name !== 'colours')
          .flatMap((name) => {
            if (name === 'planter-size') return [this.planterSize?.summary];
            if (name === 'area-size') return [this.areaSize?.summary];
            const label = this.answers[name]?.dataset.summary;
            return name === 'temp' && this.fleece ? [label, this.text.fleece_summary] : [label];
          })
          .filter(Boolean);
        this.step('colours').querySelectorAll('[aria-pressed="true"]').forEach((el) => labels.push(el.dataset.summary));
        target.replaceChildren(
          ...labels.map((label) => {
            const li = document.createElement('li');
            li.textContent = label;
            return li;
          })
        );
      }

      // Picks count plants for "Choose for me" or the planter mix and shows them with Add
      // all to cart. Nothing goes in the cart until that is pressed.
      async pick(count, { another = false } = {}) {
        const t = this.text;
        const title = this.picked.querySelector('[data-picked-title]');
        const status = this.picked.querySelector('[data-picked-status]');
        const grid = this.picked.querySelector('[data-picked-grid]');
        const actions = this.picked.querySelector('[data-picked-actions]');
        const addAll = this.picked.querySelector('[data-add-all]');
        // Every plant shown since the answers last changed, and how often.
        if (!another || !this.shown) {
          this.shown = new Map();
          this.mixes = new Set();
        }
        if (another) (this.picks || []).forEach((plant) => this.shown.set(plant.id, (this.shown.get(plant.id) || 0) + 1));

        this.lastCount = count;
        this.current = this.flow.length;
        this.view('picked');
        const screen = this.screen;
        this.care.hidden = true;
        this.planting.hidden = true;
        title.textContent = t.picking;
        status.textContent = '';
        this.renderSummary(this.picked.querySelector('[data-picked-summary]'));
        grid.replaceChildren();
        actions.hidden = true;
        this.focusTop(title);

        try {
          this.plants = await this.load();
        } catch (error) {
          if (screen !== this.screen) return;
          title.textContent = t.picked_none_title;
          status.textContent = t.error;
          return;
        }
        // The shopper went back or started again while the plants loaded.
        if (screen !== this.screen) return;

        const pool = this.plants.filter((p) => p.locations && p.available && p.variant_id);
        // Enough plants for the whole mix plus spares; the temperature only loosens far enough
        // for a few different plants plus spares.
        const distinct = Math.min(count, MIN_DISTINCT);
        const c = this.criteria();
        const { ranked, relaxed } = this.match(pool, c, count + SPARE_PLANTS, distinct + SPARE_PLANTS);
        // With few plants to choose from, a planter mix leaves some out (and doubles up the
        // others), so the next mix has plants to bring in.
        const different =
          this.route === 'planter' ? Math.min(count, Math.max(distinct, ranked.length - SPARE_PLANTS)) : count;
        const roles = this.route === 'planter' ? planterRoles(different) : Array(count).fill(null);
        this.picks = this.freshMix(this.pickVaried(ranked, roles, this.shown), ranked);
        // A big planter can need more plants than there are different ones in stock that
        // suit it, so the fillers and trailing plants double up (never the centrepiece).
        this.quantities = new Map(this.picks.map((plant) => [plant.id, 1]));
        const extras = this.route === 'planter' ? this.picks.filter((plant) => plant.role !== 'tall') : [];
        for (let left = count - this.picks.length, i = 0; left > 0 && extras.length; left--, i++) {
          const plant = extras[i % extras.length];
          this.quantities.set(plant.id, this.quantities.get(plant.id) + 1);
        }
        // Too few plants in stock can still leave a planter at 2 or 4, so one comes out,
        // the last filler or trailing plant if there is one.
        const sum = () => [...this.quantities.values()].reduce((total, n) => total + n, 0);
        if (this.route === 'planter' && AVOID_COUNTS.includes(sum())) {
          const drop = this.picks.findLast((plant) => plant.role !== 'tall') || this.picks.at(-1);
          this.picks = this.picks.filter((plant) => plant !== drop);
          this.quantities.delete(drop.id);
        }
        const total = sum();

        if (!this.picks.length) {
          title.textContent = t.picked_none_title;
          status.innerHTML = t.none.replace('[help]', t.help_url);
          actions.hidden = false;
          addAll.hidden = true;
          return;
        }

        const heading =
          this.route === 'planter'
            ? total === 1
              ? t.planter_title_one
              : t.planter_title
            : this.picks.length === 1
              ? t.picked_title_one
              : t.picked_title;
        title.textContent = heading.replace('[count]', total);
        const short =
          total >= count
            ? ''
            : this.route === 'planter'
              ? t.planter_short
              : total === 1
                ? t.picked_short_one
                : t.picked_short.replace('[count]', total);
        status.textContent = [this.relaxedNote(relaxed, this.picks, c, t.picked_relaxed), short].filter(Boolean).join(' ');
        grid.replaceChildren(
          ...this.picks.map((plant) => this.card(plant, { addButton: false, role: plant.role, quantity: this.quantities.get(plant.id) }))
        );
        addAll.hidden = false;
        addAll.disabled = false;
        addAll.textContent = t.add_all;
        delete addAll.dataset.view;
        actions.hidden = false;
        this.renderPlanting();
        this.renderCare(this.picks);
      }

      // The planting zones of a planter mix, each with the picked plants that go in it. A
      // zone with none of the mix's plants in it is left out.
      renderPlanting() {
        const t = this.text;
        if (this.route !== 'planter' || !this.picks.length) {
          this.planting.hidden = true;
          return;
        }
        const items = ZONES.flatMap((zone) => {
          const names = this.picks
            .filter((plant) => zoneOf(plant) === zone)
            .map((plant) => {
              const name = plant.title.split(' | ')[0];
              const count = this.quantities.get(plant.id);
              return count > 1 ? t.zone_quantity.replace('[plant]', name).replace('[count]', count) : name;
            });
          if (!names.length) return [];
          const item = document.createElement('li');
          item.className = 'ss-finder__care-item';
          const icon = document.createElement('span');
          icon.className = 'ss-finder__care-icon';
          icon.setAttribute('aria-hidden', 'true');
          const svg = this.factIcons.querySelector(`[data-icon="zone_${zone}"] svg`);
          if (svg) icon.append(svg.cloneNode(true));
          const body = document.createElement('div');
          const heading = document.createElement('h4');
          heading.textContent = t[`zone_${zone}`];
          const paragraph = document.createElement('p');
          paragraph.textContent = t[`zone_${zone}_text`];
          const plants = document.createElement('p');
          plants.className = 'ss-finder__zone-plants';
          plants.textContent = t.zone_plants.replace('[plants]', names.join(', '));
          body.append(heading, paragraph, plants);
          item.append(icon, body);
          return [item];
        });
        this.planting.querySelector('[data-planting-list]').replaceChildren(...items);
        this.planting.hidden = false;
      }

      // A mix that has been shown already for these answers gets one plant changed, the
      // last one that can be, for the least shown plant that could take its place: one of
      // the same role if possible, otherwise any (but never a trailing centrepiece).
      freshMix(picks, ranked) {
        const key = (mix) => mix.map((plant) => plant.id).sort().join();
        const swapIn = (mix, slot, plant) => mix.map((each, i) => (i === slot ? plant : each));
        if (this.mixes.has(key(picks))) {
          const others = ranked
            .map((r) => r.plant)
            .filter((plant) => !picks.includes(plant))
            .sort((x, y) => (this.shown.get(x.id) || 0) - (this.shown.get(y.id) || 0));
          const loosely = (plant, role) => (role === 'tall' ? !hasForm(plant, ROLES.trailing) : true);
          find: for (const fits of [this.fitsSlot.bind(this), loosely]) {
            for (let slot = picks.length - 1; slot >= 0; slot--) {
              const role = picks[slot].role;
              const next = others.find((plant) => fits(plant, role) && !this.mixes.has(key(swapIn(picks, slot, plant))));
              if (next) {
                next.role = role === 'tall' || !role ? role : formRole(next);
                picks = swapIn(picks, slot, next);
                break find;
              }
            }
          }
        }
        this.mixes.add(key(picks));
        return picks;
      }

      // Could the plant take a picked plant's place in a mix? The same role, or for a
      // centrepiece any tall plant that isn't trailing.
      fitsSlot(plant, role) {
        if (!role) return true;
        if (role === 'tall') return hasForm(plant, ROLES.tall) && !hasForm(plant, ROLES.trailing);
        return formRole(plant) === role;
      }

      async addAll(button) {
        const t = this.text;
        const status = this.picked.querySelector('[data-picked-status]');
        button.disabled = true;
        button.textContent = t.adding;
        try {
          if (await this.addToCart(this.picks.map((plant) => ({ id: plant.variant_id, quantity: this.quantities.get(plant.id) || 1 })))) {
            const cart = await this.withDiscount();
            this.cartChanged(cart);
            const discounted = (cart.discount_codes || []).some(
              (discount) => discount.applicable && discount.code.toUpperCase() === this.discountCode.toUpperCase()
            );
            status.textContent = discounted ? t.added_all_discount.replace('[saving]', t.saving) : t.added_all;
            // The same button now opens the cart.
            button.textContent = t.view_cart;
            button.dataset.view = 'true';
            button.disabled = false;
            return;
          }
        } catch (error) {
          status.textContent = error.message || t.cart_error;
        }
        button.textContent = t.add_all;
        button.disabled = false;
      }

      async addOne(button) {
        const t = this.text;
        const error = button.closest('.ss-finder__card').querySelector('.ss-finder__card-error');
        error.hidden = true;
        button.disabled = true;
        button.textContent = t.adding;

        try {
          if (await this.addToCart([{ id: Number(button.dataset.variantId), quantity: 1 }])) {
            this.cartChanged(await this.withDiscount());
            button.textContent = t.added;
            await new Promise((resolve) => setTimeout(resolve, 2000));
          }
        } catch (err) {
          error.textContent = err.message || t.cart_error;
          error.hidden = false;
        }
        button.textContent = t.add;
        button.disabled = false;
      }

      // Adds the items in one request. Resolves false if a US shopper declines the import
      // permit check (assets/us-plant-limit.js), and throws with Shopify's message on errors.
      async addToCart(items) {
        let confirmPlantLimit = async () => true;
        try {
          ({ confirmPlantLimit } = await import('@theme/us-plant-limit'));
        } catch (error) {
          console.warn('[plant-finder] could not load the US plant limit check:', error);
        }
        const plants = items.reduce((sum, item) => sum + item.quantity, 0);
        if (!(await confirmPlantLimit({ add: plants }))) return false;

        const response = await fetch(routes().cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.text.cart_error);
        return true;
      }

      async getCart() {
        return (await fetch(cartJsUrl(), { headers: JSON_HEADERS })).json();
      }

      // Puts the finder's discount code (the section's discount_code, FOUND5) on the cart,
      // keeping any codes already there, and returns the cart. Shopify applies it to the
      // plants the code covers in the admin.
      async withDiscount() {
        const cart = await this.getCart();
        const code = this.discountCode;
        const codes = (cart.discount_codes || []).map((discount) => discount.code);
        if (!code || codes.some((existing) => existing.toUpperCase() === code.toUpperCase())) return cart;
        try {
          const response = await fetch(`${routes().cart_update_url || '/cart/update'}.js`, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ discount: [...codes, code].join(',') }),
          });
          if (response.ok) return response.json();
        } catch (error) {
          console.warn('[plant-finder] could not apply the discount code:', error);
        }
        return cart;
      }

      loadCare() {
        if (!this.careLoading) {
          this.careLoading = fetch(this.dataset.careUrl)
            .then((response) => {
              if (!response.ok) throw new Error(`Plant finder care: ${response.status}`);
              return response.json();
            })
            .catch((error) => {
              this.careLoading = null;
              throw error;
            });
        }
        return this.careLoading;
      }

      // Which care topics matter for where the plants will live, in order. At most one of
      // light and summer, to keep the summary short.
      // An outdoor area leaves out planting: the care profiles open that topic with potting
      // compost and pots, and plants in the ground stay out all year.
      careTopics() {
        if (this.route === 'area') return ['aftercare', 'watering', 'summer_care', 'winter_care'];
        const planter = this.route === 'planter';
        const place = this.place;
        const outdoors = !this.indoor;
        const comesIn = planter ? Boolean(place?.dataset.temp) : this.answer('temp')?.dataset.temp === '5';
        const topics = ['aftercare', 'compost', 'watering'];
        if (!outdoors || comesIn) topics.push('light');
        else topics.push('summer_care');
        topics.push('winter_care');
        return topics;
      }

      // The opening sentences of a care topic, with its placeholders filled. For one plant
      // they take its own details, as on its product page. For several they talk about the
      // group (groupSentence), and sentences that need one plant's details are left out.
      // keep, for a group that doesn't all use this profile, trims each sentence to what suits
      // every plant, or returns '' to leave it out (suitsAll).
      careSentences(text, plants, limit, keep) {
        const t = this.text;
        const one = plants.length === 1 ? plants[0] : null;
        const values = one
          ? {
              plant: one.title.split(' | ')[0],
              hardiness: one.min_temp !== null ? `${one.min_temp}°C` : '',
              hardiness_celsius: one.min_temp !== null ? `${one.min_temp}°C` : '',
              growth_rate: one.growth_rate || '',
              maximum_size: one.size || '',
              maximum_height_and_spread: one.size || '',
              colour: (one.colours || []).join(', '),
              featured_colour: (one.colours || []).join(', '),
              growability: one.growability || '',
              sunlight: one.sunlight || '',
              sunlight_amount: one.sunlight || '',
              recommended_locations: (one.locations || []).join(', '),
              growth_form: (one.form || []).join(', '),
            }
          : null;
        const genera = new Set(plants.map((plant) => genus(plant.title)));

        const sentences = [];
        let named = false;
        let leftOut = false;
        let anyLeftOut = false;
        for (const paragraph of (text || '').split(/\n\s*\n/)) {
          let aboutPlant = false;
          // A new sentence starts with a capital, so "John Innes No. 2" stays whole.
          for (const sentence of paragraph.split(/(?<=[.!?])\s+(?=[A-Z])/)) {
            const keys = [...sentence.matchAll(/\[([a-z_]+)\]/g)].map((m) => m[1]);
            if (keys.includes('plant')) aboutPlant = true;
            let filled;
            if (one) {
              if (!keys.every((key) => values[key])) continue;
              filled = sentence.replace(/\[([a-z_]+)\]/g, (m, key) => values[key]);
            } else {
              if (keys.some((key) => key !== 'plant')) continue;
              // A sentence that points back ("Once this growth has stretched", "The flowers
              // open in sunshine", "to bring out this colour") goes with the one before it when
              // keep leaves that out. "it" doesn't count: in care text it is nearly always the
              // plant.
              const pointsBack = /^The\b|^(?:\w+,?\s+){0,3}(?:that|such|they|their)\b|\b(?:this|these|those)\b/i.test(sentence);
              const suits = leftOut && pointsBack ? '' : keep ? keep(sentence) : sentence;
              leftOut = !suits;
              anyLeftOut = anyLeftOut || leftOut;
              if (!suits) continue;
              filled = groupSentence(suits, aboutPlant ? 'paragraph' : named ? 'topic' : '', genera);
            }
            filled = filled.trim();
            if (filled) sentences.push(filled);
            if (sentences.length >= limit) return sentences.join(' ');
          }
          // Stay within the opening paragraph once it has given something. If keep left out
          // all it had, the later paragraphs build on it, so the topic ends there.
          if (sentences.length || anyLeftOut) break;
          named = named || aboutPlant;
        }
        return sentences.join(' ');
      }

      // One short care summary for the plants on show, from the care profile most of them
      // share: no per-plant blocks, nothing to open.
      async renderCare(plants) {
        const t = this.text;
        const token = (this.careToken = (this.careToken || 0) + 1);
        let profiles;
        try {
          profiles = await this.loadCare();
        } catch (error) {
          this.care.hidden = true;
          return;
        }
        if (token !== this.careToken) return;

        const counts = new Map();
        plants.forEach((plant) => {
          if (plant.care && profiles[plant.care]) counts.set(plant.care, (counts.get(plant.care) || 0) + 1);
        });
        if (!counts.size) {
          this.care.hidden = true;
          return;
        }
        // Map keeps first-seen order, so a tie goes to the earlier (closer) match.
        const lead = [...counts].reduce((best, entry) => (entry[1] > best[1] ? entry : best))[0];
        const profile = profiles[lead];

        this.care.querySelector('[data-care-title]').textContent =
          this.route === 'planter' ? t.care_title_planter : plants.length === 1 ? t.care_title_one : t.care_title;
        const place = this.place?.dataset.carePlace;
        this.care.querySelector('[data-care-intro]').textContent = place
          ? t.care_intro.replace('[place]', place)
          : t.care_intro_any;

        const limits = { aftercare: 2, compost: 2, watering: 3, light: 2, summer_care: 2, winter_care: 2 };
        // When some plants here use another profile, a sentence has to suit them all
        // (suitsAll), and a topic left with nothing comes from the general succulent profile.
        // A part counts for a plant if its own profile mentions it; the general profile is
        // written for any succulent, so it counts for nothing.
        const known = new Set([...(this.plants || []), ...plants].map((plant) => genus(plant.title)));
        const ownText = new Map();
        const profileText = (plant) => {
          if (!profiles[plant.care] || plant.care === GENERAL_CARE) return '';
          if (!ownText.has(plant.care)) ownText.set(plant.care, Object.values(profiles[plant.care]).join(' '));
          return ownText.get(plant.care);
        };
        const topicText = (handle, topic) => {
          const mixed = plants.some((plant) => plant.care !== handle);
          const keep = mixed ? (sentence) => suitsAll(sentence, plants, known, profileText) : null;
          const text = this.careSentences(profiles[handle][topic], plants, limits[topic], keep);
          if (!mixed || handle === GENERAL_CARE || !profiles[GENERAL_CARE]) return text;
          // The opening sentence carries a topic's main advice. If it had to go, what's left is
          // a side note ("Trim back encroaching growth…"), so the general profile gives it instead.
          const opening = (sentences) => sentences.split(/(?<=[.!?])\s+(?=[A-Z])/)[0];
          const unfiltered = this.careSentences(profiles[handle][topic], plants, limits[topic], null);
          if (text && opening(text) === opening(unfiltered)) return text;
          return this.careSentences(profiles[GENERAL_CARE][topic], plants, limits[topic], keep) || text;
        };
        const items = this.careTopics().map((topic) => {
          let text = topicText(lead, topic);
          // With several plants, the least hardy one sets the limit for all of them, so winter
          // follows that plant's own care profile.
          if (topic === 'winter_care' && plants.length > 1) {
            const tender = plants
              .filter((plant) => plant.min_temp !== null)
              .reduce((most, plant) => (!most || plant.min_temp > most.min_temp ? plant : most), null);
            if (tender) {
              text = topicText(profiles[tender.care]?.winter_care ? tender.care : lead, topic);
              text = `${t.care_tender.replace('[plant]', tender.title.split(' | ')[0]).replace('[temp]', tender.min_temp)} ${text}`.trim();
            }
          }
          if (!text) return null;

          const item = document.createElement('li');
          item.className = 'ss-finder__care-item';
          const icon = document.createElement('span');
          icon.className = 'ss-finder__care-icon';
          icon.setAttribute('aria-hidden', 'true');
          const svg = this.factIcons.querySelector(`[data-icon="${topic}"] svg`);
          if (svg) icon.append(svg.cloneNode(true));
          const body = document.createElement('div');
          const heading = document.createElement('h4');
          heading.textContent = t[`topic_${topic}`];
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          body.append(heading, paragraph);
          item.append(icon, body);
          return item;
        });
        this.care.querySelector('[data-care-list]').replaceChildren(...items.filter(Boolean));

        const guide = this.care.querySelector('[data-care-guide]');
        guide.hidden = !profile.guide_url;
        if (profile.guide_url) guide.href = profile.guide_url;
        this.care.hidden = false;
      }

      // Tells the cart icon and drawer that the cart changed, as the product form does.
      async cartChanged(cart) {
        try {
          const { CartAddEvent } = await import('@theme/events');
          this.dispatchEvent(new CartAddEvent({}, 'plant-finder', { source: 'plant-finder', itemCount: cart.item_count }));
        } catch (error) {
          console.warn('[plant-finder] could not update the cart icon:', error);
        }
      }

      openCart() {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = routes().cart_url || '/cart';
      }

      card(plant, { addButton = true, role = null, quantity = 1 } = {}) {
        const t = this.text;
        const li = document.createElement('li');
        li.className = 'ss-finder__card';

        const media = document.createElement('div');
        media.className = 'ss-finder__card-media';
        if (plant.image) {
          const img = document.createElement('img');
          img.src = plant.image;
          img.alt = plant.alt || '';
          img.loading = 'lazy';
          img.width = 480;
          img.height = 480;
          media.append(img);
        }
        if (!plant.available) {
          const badge = document.createElement('span');
          badge.className = 'ss-finder__badge';
          badge.textContent = t.sold_out;
          media.append(badge);
        } else if (role) {
          const badge = document.createElement('span');
          badge.className = 'ss-finder__badge ss-finder__badge--role';
          badge.textContent = t[`role_${role}`];
          media.append(badge);
        }
        const title = document.createElement('h4');
        title.className = 'ss-finder__card-title';
        const link = document.createElement('a');
        link.href = plant.url;
        link.textContent = plant.title;
        title.append(link);

        // The price of the pot size the button adds, with its name when there's a choice.
        const price = document.createElement('p');
        price.className = 'ss-finder__card-price';
        price.textContent = plant.available && plant.variant_price ? plant.variant_price : plant.price;
        if (quantity > 1) price.textContent = t.quantity.replace('[count]', quantity).replace('[price]', price.textContent);
        if (plant.available && plant.variant_title) {
          const pot = document.createElement('span');
          pot.className = 'ss-finder__card-variant';
          pot.textContent = plant.variant_title;
          price.append(pot);
        }

        const facts = document.createElement('ul');
        facts.className = 'ss-finder__facts';
        const sun = sunLevel(plant.sunlight);
        const items = [
          ['sun', sun ? t[`sun_${sun}`] : null],
          ['temp', plant.min_temp !== null ? t.temp.replace('[temp]', plant.min_temp) : null],
          [
            'size',
            plant.height_cm && plant.spread_cm
              ? t.size.replace('[height]', plant.height_cm).replace('[spread]', plant.spread_cm)
              : null,
          ],
        ];
        items
          .filter(([, text]) => text)
          .forEach(([icon, text]) => {
            const item = document.createElement('li');
            const svg = this.factIcons.querySelector(`[data-icon="${icon}"] svg`);
            if (svg) item.append(svg.cloneNode(true));
            item.append(text);
            facts.append(item);
          });

        li.append(media, title, price, facts);

        if (addButton && plant.available && plant.variant_id) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button button-secondary ss-finder__add';
          button.dataset.add = '';
          button.dataset.variantId = plant.variant_id;
          button.textContent = t.add;
          button.setAttribute('aria-label', `${t.add}: ${plant.title}`);
          const error = document.createElement('p');
          error.className = 'ss-finder__card-error';
          error.setAttribute('role', 'alert');
          error.hidden = true;
          li.append(button, error);
        }
        return li;
      }

    }

    customElements.define('ss-plant-finder', SsPlantFinder);
  })();

  } catch(e) { console.error(e); }
})();
})();
